import { ComponentType } from 'react';
import {
  Dashboard,
  SwapHoriz,
  CreditCard,
  Settings,
  CheckCircle,
  Rocket
} from '@mui/icons-material';
import TransactionsPage from '../pages/transactions/TransactionsPage';
import SendMoneyPage from '../pages/transfer/SendMoneyPage';
import SendMoneyFromBankToAccount from '../pages/transfer/SendMoneyFromBankToAccount';
import BulkTransferPage from '../pages/transfer/BulkTransferPage';
import UsersPage from '../pages/settings/UsersPage';
import RolesPage from '../pages/settings/RolesPage';
import PendingApprovalsPage from '../pages/approvals/PendingApprovalsPage';
import ApprovalHistoryPage from '../pages/approvals/ApprovalHistoryPage';
import SentApprovalsPage from '../pages/approvals/SentApprovalsPage';
import SendMoneyToBank from '../pages/transfer/SendMoneyToBank';
import Fast from '../pages/fast/fast';
import CardListPage from '../pages/cards/card-list/CardListPage';
import MealCards from '../pages/cards/meal-cards/MealCards';
import MealAllowancePage from '../pages/cards/meal-allowance/MealAllowancePage';
import AuthorizationPage from '../pages/settings/AuthorizationPage';

export interface SubMenuItem {
  title: string;
  text: string;
  route: string;
  component?: ComponentType;
}

export interface MenuItem {
  title: string;
  text: string;
  icon?: any;
  route: string;
  component?: ComponentType;
  children?: SubMenuItem[];
}

export const menuItems: MenuItem[] = [
  {
    title: 'Dashboard',
    text: 'Anasayfa',
    icon: Dashboard,
    route: '/dashboard',
    children: [
      {
        title: 'Transactions',
        text: 'İşlemler',
        route: '/dashboard/transactions',
        component: TransactionsPage
      }
    ]
  },
  {
    title: 'Para Transferi',
    text: 'Para Transferi',
    icon: SwapHoriz,
    route: '/transfer',
    children: [
      {
        title: 'Hesabına Para Gönder',
        text: 'Hesabına Para Gönder',
        route: '/transfer/send-money',
        component: SendMoneyPage
      },
      {
        title: 'Banka Hesabına Para Gönder',
        text: 'Banka Hesabına Para Gönder',
        route: '/transfer/send-money-to-bank',
        component: SendMoneyToBank
      },
      {
        title: 'Bankadan Hesaba Para Gönder',
        text: 'Bankadan Hesaba Para Gönder',
        route: '/transfer/send-money-from-bank-to-account',
        component: SendMoneyFromBankToAccount
      },
      {
        title: 'Toplu Para Gönder',
        text: 'Toplu Para Gönder',
        route: '/transfer/bulk',
        component: BulkTransferPage
      }
    ]
  },
  {
    title: 'FAST',
    text: 'FAST',
    icon: Rocket,
    route: '/fast',
    children: [
      {
        title: 'Para Gönder',
        text: 'Para Gönder',
        route: '/fast/fast',
        component: Fast
      }
    ]
  },
  {
    title: 'Kart',
    text: 'Kart',
    icon: CreditCard,
    route: '/cards',
    children: [
      {
        title: 'Kart İşlemleri',
        text: 'Kart İşlemleri',
        route: '/cards/list',
        component: CardListPage
      },
      {
        title: 'Yemek Kartı',
        text: 'Yemek Kartı',
        route: '/cards/bulk-meal-card',
        component: MealCards
      },
      {
        title: 'Bakiye Yükleme Talimatları',
        text: 'Bakiye Yükleme Talimatları',
        route: '/cards/meal-allowance',
        component: MealAllowancePage
      }
    ]
  },
  {
    title: 'Ayarlar',
    text: 'Ayarlar',
    icon: Settings,
    route: '/settings',
    children: [
      {
        title: 'Kullanıcı Listesi',
        text: 'Kullanıcı Listesi',
        route: '/settings/users',
        component: UsersPage
      },
      {
        title: 'Rol Ekle',
        text: 'Rol Ekle',
        route: '/settings/roles',
        component: RolesPage
      },
      {
        title: 'Yetkilendirme',
        text: 'Yetkilendirme',
        route: '/settings/authorizations',
        component: AuthorizationPage
      }
    ]
  },
  {
    title: 'Onay İşlemleri',
    text: 'Onay İşlemleri',
    icon: CheckCircle,
    route: '/maker-checker',
    children: [
      {
        title: 'Onaya Gelen İşlemler',
        text: 'Onaya Gelen İşlemler',
        route: '/maker-checker/maker-checker',
        component: PendingApprovalsPage
      },
      {
        title: 'Onayladıklarım/Reddetiklerim',
        text: 'Onayladıklarım/Reddetiklerim',
        route: '/maker-checker/approved-rejected',
        component: ApprovalHistoryPage
      },
      {
        title: 'Onaya Gönderdiklerim',
        text: 'Onaya Gönderdiklerim',
        route: '/maker-checker/sent-for-approval',
        component: SentApprovalsPage
      }
    ]
  }
];

export default menuItems;